module.exports = __webpack_public_path__ + "static/media/tab_cover_select.1d19dbb3.svg";